import React from "react";
import PropTypes from "prop-types";

import ForcedViewPrivateTopBarView from "../views/ForcedViewPrivateTopBarView";
import FooterView from "../views/FooterView";

class ForcedViewPrivateWrapper extends React.Component {

    static propTypes = {
        children: PropTypes.object.isRequired,
        usesDefaultFooter: PropTypes.bool.isRequired
    };

    render() {
        let footer = null;
        if (this.props.usesDefaultFooter) {
            footer = (
                <div className="footer-contents mt-4">
                    <FooterView/>
                </div>
            );
        }

        return (
            <div className="main-contents">
                <ForcedViewPrivateTopBarView />
                <div className="middle-contents">
                    {this.props.children}
                </div>
                {footer}
            </div>
        );
    }
}

export default ForcedViewPrivateWrapper;